var React = require('react');

function HumanCell (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M107 160a80.003 80.003 0 01-73.91-49.385A80.001 80.001 0 01107 0v7.842a72.158 72.158 0 100 144.316V160z","fill":"#101010","key":0}),React.createElement("path",{"d":"M107 152a72.002 72.002 0 01-72-72 72 72 0 0172-72v144z","fill":"#EBEBEB","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.242 60.414a2 2 0 00-2.828 2.828l12.512 12.512c.113.114.237.211.369.292.352.572.984.954 1.705.954h32a2 2 0 100-4H16.825a1.976 1.976 0 00-.071-.074L4.242 60.414zM4.242 99.586a2 2 0 01-2.828-2.828l12.512-12.512c.113-.114.237-.211.369-.292A1.999 1.999 0 0116 83h32a2 2 0 110 4H16.825l-.071.074L4.242 99.586z","fill":"#19E99E","key":2})]);
}

HumanCell.defaultProps = {"fill":"none","viewBox":"0 0 107 160"};

module.exports = HumanCell;

HumanCell.default = HumanCell;
